import React from "react";

export default function SQLServer_DATENAME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DATENAME</h1>
      <p>This is the SQLServer_DATENAME component generated from the SQL JSON.</p>
    </div>
  );
}
